import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const wholesaleConsumptionService = new Service('/storage/movements/wholesale-consumption', HALApiService, createItemsData)
